import React from "react";

export const ThinArrowLine = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
  >
    <path
      d="M21.27 8.23231L17.4484 4.41064L16.27 5.58898L19.8217 9.14148H0V10.8081H19.8717L16.2692 14.4106L17.4475 15.589L21.27 11.7673C21.7373 11.2977 21.9996 10.6622 21.9996 9.99981C21.9996 9.33737 21.7373 8.70188 21.27 8.23231Z"
      fill="currentColor"
    />
  </svg>
);
